<template>
    <!-- sandbox ohne allow-scripts: Skripte aus empfangenen Mails laufen nicht und kommen nicht an Travelize heran.
         allow-popups(-to-escape-sandbox): Links öffnen in einem neuen, normalen Tab -->
    <iframe
        width="100%"
        v-bind:height="email.attachments && nrOfAttachments > 0 ? '720' : customHeight"
        sandbox="allow-popups allow-popups-to-escape-sandbox"
        :srcdoc="frameHtml"
    ></iframe>
</template>



<script>
import store from '../store';


const baseURL = window.location.origin;


export default {
    props: {
        email:        { type: Object, required: true },
        customHeight: { type: String, default: '950' }
    },


    computed: {
        nrOfAttachments: function () {
            if (this.email.attachments) {
                return this.email.attachments.filter(attachment => attachment.disposition !== 'inline' || attachment.type !== 'image').length;

            } else {
                return 0;
            }
        },


        textHtml: function () {
            let html = this.email.textHtml;

            if (this.email.attachments) {
                if (this.$store.getters.isLive(this.email)) {

                    const user = localStorage.getItem('user');
                    const token = user ? JSON.parse(user).token : '';

                    for (const attachment of this.email.attachments) {
                        if ((attachment.disposition === 'inline' || !attachment.disposition) && attachment.type === 'image') {
                            html = html.replace(
                                    new RegExp('cid:' + attachment.id, 'g'),
                                    baseURL + '/api/emails/live/download_attachment/' + this.email.uid + '/' + attachment.id + '?folder=' + this.email.folder + '&bearer=' + token
                                );
                        }
                    }

                } else {
                    for (const attachment of this.email.attachments) {
                        if ((attachment.disposition === 'inline' || !attachment.disposition) && attachment.type === 'image') {
                            html = html.replace(
                                    new RegExp('cid:' + attachment.id, 'g'),
                                    '/files/' + attachment.filePath
                                );
                        }
                    }
                }
            }

            // Fallback: replace relative paths with absolute paths for signature images
            if (html) {
                html = html.replace(/\.\.\/\.\.\/clientSpecific\/email\//g, '/clientSpecific/email/');
                html = html.replace(/\.\.\/clientSpecific\/email\//g, '/clientSpecific/email/');
            }

            return html;
        },

        // jeder Link öffnet einen neuen Tab (auch ohne eigenes target)
        frameHtml: function () {
            const html = this.textHtml
                ? this.textHtml
                : (this.email.textPlain ? escapeHtml(this.email.textPlain).replace(/\n/g, '<br />') : 'Die Email enthält keinen Text');
            const base = '<base target="_blank">';
            return /<head[^>]*>/i.test(html) ? html.replace(/<head([^>]*)>/i, `<head$1>${base}`) : base + html;
        }
    },


}

function escapeHtml(text) {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
</script>
